export class ProposalPremiumBreakupDO {
    
    public id: null;
    public getid(): null {
        return this.id;
    }
    public setid(value: null) {
        this.id = value;
    }
    
    public discountPrct: Number = null;
    public getdiscountPrct(): Number {
        return this.discountPrct;
    }
    public setdiscountPrct(value: Number) {
        this.discountPrct = value;
    }
    
    public discount: Number = null;
    public getdiscount(): Number {
        return this.discount;
    }
    public setdiscount(value: Number) {
        this.discount = value;
    }
    
    public commissionPrct: Number = null;
    public getcommissionPrct(): Number {
        return this.commissionPrct;
    }
    public setcommissionPrct(value: Number) {
        this.commissionPrct = value;
    }
    
    public commission: Number = null;
    public getcommission(): Number {
        return this.commission;
    }
    public setcommission(value: Number) {
        this.commission = value;
    }
    
    public adminCharges: Number = null;
    public getadminCharges(): Number {
        return this.adminCharges;
    }
    public setadminCharges(value: Number) {
        this.adminCharges = value;
    }
    
    public stampDuty: Number = null;
    public getstampDuty(): Number {
        return this.stampDuty;
    }
    public setstampDuty(value: Number) {
        this.stampDuty = value;
    }
    
    public totalBasePremium: Number = null;
    public gettotalBasePremium(): Number {
        return this.totalBasePremium;
    }
    public settotalBasePremium(value: Number) {
        this.totalBasePremium = value;
    }
    
    public totalExtraPremium: Number = null;
    public gettotalExtraPremium(): Number {
        return this.totalExtraPremium;
    }
    public settotalExtraPremium(value: Number) {
        this.totalExtraPremium = value;
    }
    
    public totalPremiumAmt: Number = null;
    public gettotalPremiumAmt(): Number {
        return this.totalPremiumAmt;
    }
    public settotalPremiumAmt(value: Number) {
        this.totalPremiumAmt = value;
    }
}